// extracted by mini-css-extract-plugin
export default {"loaderConteiner":"loaderConteiner--DoW_3","loaderConteinerHide":"loaderConteinerHide--q21dP","loader":"loader--d6Nuj"};